import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/views/Layout.vue'
import ImageManage from '@/views/ImageManage.vue'
import NavManage from '@/views/NavManage.vue'
import Login from '@/views/Login.vue'

Vue.use(VueRouter)

// 新增：修复 NavigationDuplicated 重复路由跳转报错
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    // 只忽略【重复跳转到当前页面】的错误，其他错误正常抛出
    if (err.name !== 'NavigationDuplicated') {
      throw err
    }
  })
}

const routes = [
  {
    path: '/',
    redirect: '/admin/imgManage'
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/admin',
    component: Layout,
    children: [
      {
        path: 'imgManage',
        component: ImageManage
      },
      {
        path: 'navManage',
        component: NavManage
      },
      {
        path: 'navDetail',
        component: () => import('@/views/NavDetail.vue')
      },
      {
        path: 'carouselManage',
        component: ()=>import('@/views/CarouselManage.vue')
      },
      {
        path: 'newsManage',
        component: ()=>import('@/views/NewsManage.vue')
      },
      {
        path: 'auditMode',    
         component: ()=>import('@/views/AuditMode.vue')
      }
    ]
  },
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由全局守卫：访问/admin开头页面，校验token
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // 访问后台管理页面
  if (to.path.startsWith('/admin')) {
    if (!token) {
      // 没有token → 跳登录页
      next('/login')
    } else {
      next()
    }
  } else {
    // 非后台页面（登录页等）直接放行
    next()
  }
})

export default router
